import { useContext } from 'react';
import { DeleteForeverOutlined } from '@mui/icons-material';

import ActionItem from '../utils/tableActionTrigger';
import { LocalesContext } from '../../localesContext';
import { DeletedReport, HandleOpenDeleteDialog } from './interfaces';

interface Props {
  item: DeletedReport;
  handleOpenDeleteDialog: HandleOpenDeleteDialog;
}

const DeleteReportTableActionTrigger = ({ item, handleOpenDeleteDialog }: Props) => {
  const locales = useContext(LocalesContext);

  return (
    <ActionItem onClick={() => handleOpenDeleteDialog(item)} item={item} tooltip={locales.tooltip.delete}>
      <DeleteForeverOutlined cursor="pointer" data-testid="delete" />
    </ActionItem>
  );
};

export default DeleteReportTableActionTrigger;
